import { hasPermission, PERMISSIONS, type Permission } from '@repo/contracts';

import { APP_ROUTES } from '@/constants/app-routes';

/**
 * The one rule for where a role lands. A role that may not read candidates
 * lands on the home route, which shows an empty state rather than redirecting
 * again, so no two guards can send a person back and forth.
 */
export const homeRouteFor = (permissions: readonly Permission[]): string =>
  hasPermission(permissions, [PERMISSIONS.candidateRead])
    ? APP_ROUTES.candidates.list
    : APP_ROUTES.home;
